"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SimpleScheduler", {
    enumerable: true,
    get: function() {
        return _SimpleScheduler.SimpleScheduler;
    }
});
const _SimpleScheduler = require("./SimpleScheduler.js");
